import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppNotification } from '@fuse/types/notification';
import { AuthService } from '../auth/auth.service';
import { timer } from 'rxjs';
import { Router } from '@angular/router';

export interface IsNewResponse {
    data: number;
}

@Injectable()

export class RecommenderService implements OnDestroy {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;

    timer: Observable<number>;
    timerSubscription: Subscription;

    onRecommendationsChanged: BehaviorSubject<any>;

    // fromNotifications = false;

    searchText: string;

    constructor(
        public _http: HttpClient,
        private _authService: AuthService,
        private _router: Router
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();

        this.onRecommendationsChanged = new BehaviorSubject({});

    }

    /**
     * Public methods
     */

    public listRecommendations(companyId, page: number = 1, limit: number = 10, orderBy: string = 'created_at', order: string = 'desc', search: string = ''): Promise<any> {

        const params = {
            limit: limit,
            order_by: 'id',
            order: order
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/recommendation/listing?page=' + page, params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onRecommendationsChanged.next(response);
                        resolve(response);
                    }, reject);
        });

    }

    public createRecommendation(data: any, company: any, lang): Promise<any> {

        const params = {
            email: data.email,
            phone_number: data.phone_number,
            first_name: data.first_name,
            last_name: data.last_name,
            preferred_lang: lang,
            date_of_birth: data.date_of_birth,
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/erp/' + company + '/recommendation/add', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.listRecommendations(company);
                        // this.onRecommendationsChanged.next(response);
                        resolve(response);
                    }, reject);
        });
    }

    public getAllRequestTypes(company: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/portal/erp/' + company + '/employee-request/get-requests')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        resolve(response);
                    }, reject);
        });
    }
    
    /**
     * Lifecycle hooks
     */

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
